import { MissingTranslationHandler } from '@ngx-translate/core';

export class MyMissingTranslationHandler implements MissingTranslationHandler {
  handle(params: any) {
    return params.key;
  }
}